import changeDifficulty from "./difficulty"

import { combineReducers } from "redux"

const rootReducer = combineReducers({
    changeDifficulty
})

export default rootReducer
